import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Heart from 'assets/Heart-Empty.svg'
import Button from 'theme/atoms/Button'
import useAccount from 'hooks/account/useAccount'
import useTranslations from 'hooks/useTranslations'

export default function EmptyWishlist() {
  const account = useAccount()
  const t = useTranslations<'templates-Wishlist'>()
  return (
    <Wrapper className="EmptyWishlist" data-cy-collection="EmptyWishlist">
      <div className="title">
        <div className="icon-wrapper">
          <Heart />
        </div>
        <p>{t('wishlist_no_products')}</p>
      </div>
      {account.loggedIn && (
        <div className="description" data-cy-state="show-loggedIn-description">
          {t('wishlist_redirect_to_shop_text')}
        </div>
      )}
      {!account.loggedIn && (
        <div className="description" data-cy-state="show-loggedOut-description">
          {t('wishlist_login_text')}
        </div>
      )}
      <div className="buttons">
        {!account.loggedIn && (
          <Button
            data-cy-state="show-login-btn"
            variation="primary"
            label={t.asText(false, 'wishlist_login')}
            to="/account/login/"
          />
        )}
        <Button
          variation={account.loggedIn ? 'primary' : 'secondary'}
          label={t.asText(false, 'wishlist_continue_shopping')}
          to="/"
        />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${theme.colors.shade.b7};
  padding: ${theme.spacing('m')};
  max-width: 640px;
  margin: 0 auto;

  > .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing('xs')};
    margin-bottom: ${theme.spacing('m')};

    @media (min-width: ${theme.ms.MD}px) {
      flex-direction: row;
      gap: ${theme.spacing('m')};
    }

    > .icon-wrapper {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;

      > svg {
        transform: scale(3);
      }
    }

    > p {
      margin: 0;
      ${theme.ty('rc-3xl', 'bold', 'rc-4xl')};
    }
  }

  > .description {
    margin-bottom: ${theme.spacing('m')};
    ${theme.ty('r-s', null, 'r-base')};
  }

  > .buttons {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing('xs')};

    @media (min-width: ${theme.ms.MD}px) {
      flex-direction: row;
      gap: ${theme.spacing('m')};
      justify-content: center;

      > .Button {
        flex-basis: 50%;
      }
    }
  }
`
